import React, { useEffect, useState } from 'react';
import { Table, Button, Card, message, Modal, Tag, Menu, Typography, Space } from 'antd';
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { BankOutlined, DeleteOutlined, ExclamationCircleOutlined, LockOutlined, SyncOutlined, UserAddOutlined, UserOutlined } from '@ant-design/icons';
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import AddUserModel from './AddUserModel';
import { useSelector } from 'react-redux';
import {
  isExporter,
  isBuyer,
  isCHA,
  isManufacturerCumExporter,
  isFreightForwarder,
} from "./../../util/helper";

const { confirm } = Modal;

const SecondaryUsers = ({ primaryUserId, isPrimaryUser }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const { isMobile } = useGetBreakpoints();
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [addUserLoading, setAddUserLoading] = useState(false);
  const fetchSecondaryUsers = async () => {
    try {
      setLoading(true);
      console.log('Fetching secondary users for primaryUserId:', primaryUserId);
      const response = await axiosInstance.get(
        `/users/primary/${primaryUserId}`
      );
      setUsers(response.data.data);
    } catch (error) {
      message.error('Failed to fetch users');
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const authUser = useSelector(({ auth }) => auth.userData);
  const companyId = authUser.companyId;
  const gstNumber = authUser.gstNumber;
  const userData = useSelector(({ auth }) => auth?.userData);
  const userId=userData.id;
  console.log("userId",userId)
  const [subscriptionData, setSubscriptionData] = useState(null);
  console.log("subscriptionData",subscriptionData)
  const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
  const [error, setError] = useState(null);
  const canAddUsers =  subscriptionData?.isActive;
console.log("canAddUsers",canAddUsers)


   const fetchSubscription = async () => {
      try {
          const response = await axiosInstance.get(
              `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${userId}`
          );
          setSubscriptionData(response.data);
          console.log("Responce from the backend ",response?.data?.subscription?.planId)

  
          if (!response.data.isActive) {
              setShowSubscriptionPlans(true);
          }
          
      } catch (err) {
          setError(err.message);
          console.error('Subscription fetch error:', err);
      } finally {
          setLoading(false);
      }
  };
  
  useEffect(() => {
      fetchSubscription();
  }, [userId]);


   const handleAddUser = async (values) => {
    // if (canAddUsers) {
    //   showUpgradeModal();
    //   return;
    // }
    
    setAddUserLoading(true);
      try {
        const response = await axiosInstance.post(
          `${BASE_API_CONFIG.baseURL}/users/add`,
          {
            email: values.email,
            password: values.password,
            companyId,
            gstNumber,
            requirePasswordChange: true,
          }
        );
        console.log("email", response);
  
        if (response.data.success) {
          message.success(
            "User added successfully. A verification email has been sent.",
            setShowAddUserModal(false),
            await fetchSecondaryUsers()
          )
      
        } else {
          throw new Error(response.data.message);
        }
      } catch (error) {
        throw new Error("Failed to add user.");
      }
     finally {
      setAddUserLoading(false);
    }
    };

    const showUpgradeModal = () => {
      Modal.info({
        title: 'Upgrade Required',
        icon: <LockOutlined />,
        content: (
          <div>
            <p>Your current plan doesn't allow adding secondary users.</p>
            <p>Please upgrade your plan to access this feature.</p>
          </div>
        ),
        okText: 'Upgrade Now',
        onOk: () => {
          window.location.href = '/subscription-User';
        }
      });
    };

  const showDeleteConfirm = (userId,email) => {
    confirm({
      title: 'Are you sure you want to delete this user?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        return handleRemoveUser(userId,email);
      },
    });
  };

  const handleRemoveUser = async (userId,email) => {
    console.log("email from the frontend add user",email)
  try {
    setDeleteLoading(true);
    
    confirm({
      title: 'Confirm Secondary User Deletion',
      content: 'This will permanently remove the secondary user. Continue?',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      async onOk() {
        const response = await axiosInstance.delete(
          `users/secondary/users/${userId}`,
          {
            data: { email },
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        
        if (response.data.success) {
          message.success('Secondary user removed successfully');
          await fetchSecondaryUsers();
        }
      }
    });
  } catch (error) {
    message.error(
      error.response?.data?.message || 
      'Failed to remove secondary user. Please try again.'
    );
  } finally {
    setDeleteLoading(false);
  }
};

  useEffect(() => {
    if (primaryUserId && isPrimaryUser) {
      fetchSecondaryUsers();
    }
  }, [primaryUserId, isPrimaryUser]);



 const renderMobileView = () => {
  return (
    <div style={{ padding: '0px' }}>
      {users.map((user) => (
        <Card
          key={user.id}
          style={{
            marginBottom: '16px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            border: 'none'
          }}
          bodyStyle={{ padding: '16px' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

             <div style={{ textAlign: 'left',display:'flex',alignContent: 'space-between' }}>
                <Typography.Text type="secondary" style={{ fontSize: '13px' }}>
                  Joined Date  - 
                </Typography.Text>
                <Typography.Text style={{ 
                  display: 'block',
                  fontSize: '13px',
                  fontWeight: 500 ,
                }}>
                     {new Date(user.createdAt).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </Typography.Text>
              </div>
            {/* Header Section */}
            <div style={{ 
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start'
            }}>


              {/* User Identity */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#f0f5ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <UserOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
                </div>
                <div>
                  <Typography.Text strong style={{ fontSize: '14px', display: 'block' }}>
                    {user.email}
                  </Typography.Text>
                  <Tag 
                    color={user.role === 'secondary' ? 'blue' : 'purple'}
                    style={{ 
                      marginTop: '4px',
                      borderRadius: '4px',
                      fontWeight: 500
                    }}
                  >
                    {user.role === 'secondary' ? 'Secondary User' : 'Primary User'}
                  </Tag>
                </div>
              </div>

              {/* Joined Date */}

 {user.role === 'secondary' && (
              <div style={{ 
                display: 'flex',
                justifyContent: 'flex-end',
                borderTop: '1px solid #f0f0f0',
                paddingTop: '16px',
                marginTop: '8px'
              }}>
                <Button
                  danger
                  size="middle"
                  icon={<DeleteOutlined />}
                  onClick={() => showDeleteConfirm(user.id, user.email)}
                  loading={deleteLoading}
                  disabled={loading}
                  style={{ 
                    borderRadius: '6px',
                    fontWeight: 400,
                    padding: '0 6px',
                    height: '36px'
                  }}
                >
                  Remove 
                </Button>
              </div>
            )}
            
             
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};


  const columns = [
    // {
    //   title: 'Name',
    //   dataIndex: 'name',
    //   key: 'name',
    //   render: (text) => text || 'N/A',
    // },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: (text) => text === 'secondary' ? 'Secondary User' : 'Primary User'
    },
    {
      title: 'companyName',
      dataIndex: 'companyName',
      key: 'companyName',
      render: (text) => text || 'Active',
    },
    {
      title: 'Joined Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => new Date(date).toLocaleDateString(),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        record.role === 'secondary' && (
          <Button 
            danger 
            onClick={() => showDeleteConfirm(record.id,record.email)}
            loading={deleteLoading}
            disabled={loading}
          >
            Remove
          </Button>
        )
      ),
    },
  ];

  return (
  <Card
      title={
         <Space 
      direction={isMobile ? "vertical" : "horizontal"} 
      align={isMobile ? "start" : "center"}
      style={{ width: isMobile ? "100%" : "auto" }}
    >
      <Typography.Text strong>Secondary Users</Typography.Text>
      {!canAddUsers && (
        <Tag color="orange" style={{ marginLeft: isMobile ? 0 : 8 }}>
          <LockOutlined /> Upgrade to add users
        </Tag>
      )}
    </Space>
      }
      className="gx-mt-4"
      extra={
        <Space wrap>
          {!isBuyer(userData) && (
            <Button
              type="primary"
              icon={<UserAddOutlined />}
              onClick={() => {
                // if (subscriptionData?.subscription?.planId === 1) {
                //   showUpgradeModal();
                // } else {
                //   setShowAddUserModal(true);
                // }
                setShowAddUserModal(true);
              }}            
              disabled={!canAddUsers}
              size={isMobile ? 'small' : 'middle'}
            >
              {isMobile ? 'Add User' : 'Add User'}
            </Button>
          )}
          <Button
            icon={<SyncOutlined />}
            onClick={fetchSecondaryUsers}
            loading={loading}
            size={isMobile ? 'small' : 'middle'}
          >
            {isMobile ? '' : 'Refresh'}
          </Button>
        </Space>
      }
    >
      {isMobile ? (
        users.length > 0 ? (
          renderMobileView()
        ) : (
          <Typography.Text type="secondary" style={{ display: 'block', textAlign: 'center', padding: 16 }}>
            No secondary users found
          </Typography.Text>
        )
      ) : (
        <Table
          columns={columns}
          dataSource={users}
          rowKey="id"
          loading={loading}
          pagination={false}
          locale={{
            emptyText: 'No secondary users found'
          }}
        />
      )}

      <AddUserModel
        visible={showAddUserModal}
        onCancel={() => setShowAddUserModal(false)}
        onAddUser={handleAddUser}
        onSubmit={handleAddUser}
      />
    </Card>
   
  );
};

export default SecondaryUsers;